<template>
    <el-dialog
        style="padding: 0 20px 20px 20px !important;"
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-button size="mini" @click="addRecords" style="margin:20px"
            >添加bid优化记录</el-button
        >
        <el-button size="mini" @click="getList">刷新列表</el-button>
        <el-table
            :data="list"
            size="mini"
            ref="multipleTable"
            class="table_content mini_div"
            border
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

			<el-table-column label="Auto-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.auto_acos }}</div>
			    </template>
			</el-table-column>

			<el-table-column label="Res-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.res_acos }}</div>
			    </template>
			</el-table-column>

			<el-table-column label="品牌-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.brand_acos }}</div>
			    </template>
			</el-table-column>

			<el-table-column label="Asin-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.asin_acos }}</div>
			    </template>
			</el-table-column>

			<el-table-column label="Skag-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.skag_acos }}</div>
			    </template>
			</el-table-column>

			<el-table-column label="Skag-Tos-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.skag_tos_acos }}</div>
			    </template>
			</el-table-column>

			<el-table-column label="Skag-Ros-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.skag_ros_acos }}</div>
			    </template>
			</el-table-column>

			<el-table-column label="长尾-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.changwei_acos }}</div>
			    </template>
			</el-table-column>
			<el-table-column label="腰部-Acos" min-width="150" align="center">
			    <template slot-scope="scope">
			        <div>{{ scope.row.yaobu_acos }}</div>
			    </template>
			</el-table-column>
            <el-table-column label="产品价格" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.product_price }}</div>
                </template>
            </el-table-column>
            <el-table-column label="点击数" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.clicks }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="高acos幅度系数"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.tower_acos }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="高点击无出单系数"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.high_click_not_order }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="低点击无出单系数"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.low_click_not_order }}</div>
                </template>
            </el-table-column>
            <el-table-column label="排除的活动" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.exclude_activity }}</div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="降bid状态" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.status == '0'">
                        <span>未解析</span>
                    </div>
                    <div v-if="scope.row.status == '1'">
                        <span>解析中</span>
                    </div>
                    <div v-if="scope.row.status == '2'">
                        <span>解析完成</span>
                    </div>
                    <div v-if="scope.row.status == '-1'">
                        <span>解析失败</span>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="降bid状态描述" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.status_str }}</div>
                </template>
            </el-table-column> -->
            <!-- <el-table-column
                label="降bid解析文件导出"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="downLoad(scope.row.parsing_path)"
                        v-if="scope.row.status == '2'"
                        >下载</el-button
                    >
                </template>
            </el-table-column> -->
            <el-table-column label="错误信息" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.parsing_err_msg }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="210" fixed="right">
                <template slot-scope="scope">
					<el-button
					    v-if="scope.row.status === -1"
					    style="margin: 5px 0 5px 10px"
					    type="danger"
					    size="mini"
					>解析失败</el-button>
					<el-button
					    style="margin: 5px 0 5px 10px"
					    type="success"
					    size="mini"
					    @click="downLoad(scope.row.parsing_path)"
					    v-if="scope.row.status == '2'"
					    >下载</el-button
					>
					<el-button
					    v-if="scope.row.status === 0"
					    style="margin: 5px 0 5px 10px"
					    type="success"
					    size="mini"
					    @click="startDecode(scope.row)"
					    >开始解析</el-button
					>
					<el-button
					    v-if="scope.row.status === 1"
					    style="margin: 5px 0 5px 10px"
					    type="success"
					    size="mini"
					    >解析中</el-button
					>
					<el-button
					    v-if="scope.row.status !== 0 && scope.row.status !== 1"
					    style="margin: 5px 0 5px 10px"
					    type="success"
					    size="mini"
					    @click="startDecode(scope.row, 1)"
					>重新解析</el-button
					>
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_records(scope.row)"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[20, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; padding-bottom: 30px"
                layout="total, sizes, prev, pager, next"
            >
            </el-pagination>
        </el-row>
        <AddBid
            :visible="ctrl.addBidDialogVisible"
            :ad_id="id"
            :title="'添加bid优化记录'"
            @close-callback="closeCllback"
            @refresh="getList()"
        ></AddBid>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/Product/Product.js'
import { downloadFileUrl } from "../../utils/method";
import AddBid from "./addBid.vue";

export default {
    name: "BidList",
    components: { AddBid },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        id: [Number, String]
    },
    data() {
        return {
            errorMsg: '',
            errorInfoShow: false,
            currentId: "",
            ctrl: {
                addBidDialogVisible: false
            },
            list: [],
            query: {
                page: 1,
                limit: 20,
                sb_ad_id: ""
            }
        };
    },
    created() {
        this.query.sb_ad_id = this.id;
        this.getList();
    },
    methods: {
        showErrorInfo(info){
            this.errorInfoShow = true;
            this.errorMsg = info.parsing_err_msg;
        },
		async startDecode(row, force = 0) {
		    if (force) {
		        await this.$confirm("是否重新运行解析任务", "提示", {
		            confirmButtonText: "确定",
		            cancelButtonText: "取消",
		            type: "warning"
		        });
		    }
		    let list = JSON.parse(JSON.stringify(this.list));
		    api.sb_reduce_bid_parsing_file({
		        id: row.id,
		        force
		    }).then(() => {
		        const index = list.findIndex(item => item.id === row.id);
		        list[index].status = 1;
		        this.list = list;
		    });
		},
        getList() {
            api.sb_reduce_bid_index(this.query).then(res => {
                console.log("---res", res);
                if (res.code === 0) {
                    this.list = res.data.list;
                    this.query.total = res.data.total;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.$emit("close-callback", isshow);
        },
        addRecords() {
            this.ctrl.addBidDialogVisible = true;
        },
        delete_records(data) {
            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning"
            }).then(() => {
                api.sb_reduce_bid_delete({ id: data.id }).then(() => {
                    this.$message.success("删除成功");
                    this.getList();
                });
            });
        },
        closeCllback() {
            this.ctrl.addBidDialogVisible = false;
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        downLoad(path) {
            if (!path) {
                return this.$message({
                    type: "error",
                    message: "无法下载！"
                });
            }
            downloadFileUrl(path);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-card__header {
    padding: 14px 20px !important;
}
/deep/ .el-tabs__content {
    overflow: visible !important;
}
/deep/ .el-card {
    overflow: visible !important;
}
/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}
.mini_div .el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
